export default [
  'Adorable',
  'Adventurous',
  'Agreeable',
  'Alert',
  'Amused',
  'Attractive',
  'Average',
  'Beautiful',
  'Blushing',
  'Brainy',
  'Brave',
  'Bright',
  'Busy',
  'Calm',
  'Careful',
  'Cautious',
  'Charming',
  'Cheerful',
  'Clever',
  'Cloudy',
  'Colorful',
  'Comfortable',
  'Concerned',
  'Cooperative',
  'Courageous',
  'Crazy',
  'Curious',
  'Cute',
  'Delightful',
  'Determined',
  'Distinct',
  'Dizzy',
  'Elated',
  'Elegant',
  'Enchanting',
  'Encouraging',
  'Energetic',
  'Enthusiastic',
  'Excited',
  'Exuberant',
  'Famous',
  'Fancy',
  'Fantastic',
  'Fierce',
  'Fine',
  'Friendly',
  'Funny',
  'Gentle',
  'Gifted',
  'Glamorous',
  'Gleaming',
  'Glorious',
  'Gorgeous',
  'Graceful',
  'Handsome',
  'Happy',
  'Healthy',
  'Helpful',
  'Hilarious',
  'Important',
  'Inquisitive',
  'Jolly',
  'Joyous',
  'Kind',
  'Light',
  'Lively',
  'Lovely',
  'Lucky',
  'Magnificent',
  'Mysterious',
  'Nice',
  'Nutty',
  'Outrageous',
  'Outstanding',
  'Perfect',
  'Pleasant',
  'Poised',
  'Powerful',
  'Precious',
  'Proud',
  'Puzzled',
  'Quaint',
  'Relieved',
  'Shiny',
  'Silly',
  'Sleepy',
  'Smiling',
  'Sparkling',
  'Splendid',
  'Stormy',
  'Strange',
  'Successful',
  'Tame',
  'Thankful',
  'Thoughtful',
  'Tough',
  'Victorious',
  'Vivacious',
  'Wandering',
  'Wide-eyed',
  'Wild',
  'Witty',
  'Zany',
]
